import * as React from 'react';
import Svg, { SvgProps, Circle, Path } from 'react-native-svg';
const Cross = (props: SvgProps) => (
  <Svg
    width={40}
    height={40}
    fill='none'
    {...props}
  >
    <Circle cx={20} cy={20} r={19.722} stroke='#000' strokeWidth={0.556} />
    <Path
      fill='#000'
      d='m14.446 26.215-.646-.661L19.338 20 13.8 14.446l.646-.661L20 19.338l5.554-5.553.646.661L20.662 20l5.538 5.554-.646.662L20 20.661l-5.554 5.553Z'
    />
  </Svg>
);
export default Cross;
